import qs from "qs";
import { Toast } from "antd-mobile";

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。",
};

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  console.error(`请求错误 ${response.status}: ${response.url}`);

  const error = new Error(errortext);
  error.name = String(response.status);
  error.response = response;
  throw error;
};

const offlinePromise = () =>
  new Promise((resolve, reject) => {
    if (!navigator.onLine) {
      reject(new Error("offline"));
    } else {
      resolve("online");
    }
  });

function requestPromise(url, option) {
  const defaultOptions = {
    credentials: "include",
    selfCase: false,
  };

  const newOptions = { ...defaultOptions, ...option };
  newOptions.headers = {
    Accept: "application/json",
    ...newOptions.headers,
  };
  if (
    newOptions.method === "POST" ||
    newOptions.method === "PUT" ||
    newOptions.method === "DELETE"
  ) {
    if (newOptions.dataType === "json") {
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      newOptions.body = qs.stringify(newOptions.body);
      newOptions.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
  }
  return fetch(url, newOptions)
    .then(checkStatus)
    .then((response) => {
      if (newOptions.method === "DELETE" || response.status === 204) {
        return response.text();
      }
      return response.json();
    })
    .then((res) => {
      if (res.iRet === 0) {
        return res;
      }
      Toast.info(res.sMsg);
    })
    .catch((e) => {
      console.log("catch e", e);
      if (e.message.toLowerCase().indexOf("failed") !== -1) {
        Toast.info("网络异常，请稍后再试");
      }
      const status = e.name;
      if (Number(status) > 400) {
        window.location.href = `${window.location.origin}/error`;
      }
    });
}

export default function request(url, option) {
  return offlinePromise()
    .then(() => {
      return requestPromise(url, option);
    })
    .catch((e) => {
      Toast.info("网络异常，请稍后再试");
      return e.message;
    });
}

export async function postRequest(
  url,
  data = {},
  requestOptions = { dataType: "json" }
) {
  return request(`${url}`, {
    method: "POST",
    body: {
      ...data,
    },
    ...requestOptions,
  });
}

export async function getRequest(url, dataType = "json") {
  return request(`${url}`, {
    method: "GET",
    dataType: dataType,
  });
}
